import { render, staticRenderFns } from "./StatementMoreAgent.vue?vue&type=template&id=5ef5c835&scoped=true&"
import script from "./StatementMoreAgent.vue?vue&type=script&lang=js&"
export * from "./StatementMoreAgent.vue?vue&type=script&lang=js&"
import style0 from "./StatementMoreAgent.vue?vue&type=style&index=0&id=5ef5c835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5c835",
  null
  
)

export default component.exports